import Component from '../inherited/Component'
import axios from 'axios'

export default class GEOIPPopup extends Component {
  constructor (elem, theme, options, ctx)  {
    super(elem, theme, options, ctx)
    this._closePopupElem = this._elem.querySelector('[data-close-popup]')
    this._switchSiteContainer = this._elem.querySelector('[data-switch-site-container]')
    this._options.flagImages = this._options.flagImages.split(",")
    this._endpoint = "https://api.ipstack.com/check?access_key=f5afe73a53b00c85d7a3a4bb003c1cd2"
    this._rememberFor = 1000 * 60 * 60 * 24 * 7
  }

  async mount () {
    let shouldShowPopup = false
    let popupEpoch = localStorage.getItem('FFC_GEO_POPUP')

    if (popupEpoch) {
      shouldShowPopup = (new Date().getTime() - new Date(Number(popupEpoch)).getTime()) >= this._rememberFor
    } else {
      shouldShowPopup = true
    }

    if (shouldShowPopup) {
      try {
        let { data } = await axios.get(this._endpoint)
        this.doPopupLogic(data)
      } catch (err) {
        console.log(err)
      }
    }

    this._elem.addEventListener('click', e => {
      if (e.target === this._elem) {
        this.closePopup()
      }
    })

    this._closePopupElem.addEventListener('click', e => {
      this.closePopup()
    })
  }


  doPopupLogic (data) {
    let website
    
    for (let site of this._options.sites) {
      if (site.countries.includes(data.country_code)) {
        website = site.redirect
        if (website == this._options.siteCountry) return
      }
    }
    if (data.country_code === 'JE') data.country_code = 'UK'
    if (data.country_code === 'GG') data.country_code = 'UK'
   
    if (website && this._options.siteCountry != data.country_code) {
      let nextSite = website
      let nextSiteImage = ''
      let nextCurrency = ''
      let nextSiteURL = ''
      let nextStore = ''
      let currency = ''
      let countryOrigin = data.country_name;
      if (nextSite == 'UK') {
        nextSiteImage = this._options.flagImages[0]
        nextCurrency = '£'
        currency = '€'
        nextStore = 'UK store'
        nextSiteURL = '//raidlondon.com'
      }
      if (nextSite == 'EU') {
        nextSiteImage = this._options.flagImages[3]
        nextCurrency = '€'
        currency = '£'
        nextStore = 'EU store'
        nextSiteURL = '//raidlondon.eu'
      }

      let preferText = this._options.preferText.replace("[currency]", nextCurrency).replace("[flag-origin]", " <img src="+this._options.flagImages[1]+"/>").replace("[country-origin]",countryOrigin).replace("[currency-origin]",currency).replace("[flag]"," <img src="+nextSiteImage+"/>").replace("[country-code]",nextStore);
      this._switchSiteContainer.innerHTML = `
        <p class="geo-popup-text">${preferText}</p>

        <a class="geo-popup-redirect-link" href="${nextSiteURL}" aria-label="${this._options.switchText.replace("[country]", nextSite)}">
          <span class="geo-popup-btn">${this._options.switchText.replace("[country]", nextSite)}</span>
        </a>
      `
      this._elem.classList.add('shown')
      this._hideOtherPopups()

    }
    else if  (this._options.siteCountry == 'EU' && (data.country_code != 'UK' || data.country_code != 'JE' || data.country_code != 'GG')) {
      let nextSite = 'UK'
      let nextSiteImage = ''
      let nextCurrency = ''
      let nextSiteURL = ''
      let nextStore = ''
      let currency = ''
      let countryOrigin = data.country_name;
        nextSiteImage = this._options.flagImages[0]
        nextCurrency = '£'
        currency = '$'
        nextStore = 'UK store'
        nextSiteURL = '//raidlondon.com'
        let preferText = this._options.preferText.replace("[currency]", nextCurrency).replace("[flag-origin]", " <img src="+this._options.flagImages[1]+"/>").replace("[country-origin]",countryOrigin).replace("[currency-origin]",currency).replace("[flag]"," <img src="+nextSiteImage+"/>").replace("[country-code]",nextStore);
        this._switchSiteContainer.innerHTML = `
          <p class="geo-popup-text">${preferText}</p>
  
          <a class="geo-popup-redirect-link" href="${nextSiteURL}" aria-label="${this._options.switchText.replace("[country]", nextSite)}">
            <span class="geo-popup-btn">${this._options.switchText.replace("[country]", nextSite)}</span>
          </a>
        `
        this._elem.classList.add('shown')
        this._hideOtherPopups()
    }
  }

  closePopup() {
    this._elem.classList.remove('shown')
    localStorage.setItem("FFC_GEO_POPUP", new Date().getTime())
    this._showOtherPopups()
  }

  _hideOtherPopups () {
    if (!document.querySelector('#onetrust-banner-sdk')) {
      for(let popupElement of document.querySelectorAll('[data-popup-that-can-be-hidden]')) {
        popupElement.classList.add('hide')
      }
    }
  }

  _showOtherPopups () {
    if (!document.querySelector('#onetrust-banner-sdk')) {
      for(let popupElement of document.querySelectorAll('[data-popup-that-can-be-hidden]')) {
        popupElement.classList.remove('hide')
      }
    }
  }
}